
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { ListFilterOption } from '../../global/components/List/filters.vue'
import ListComponent from '../../global/components/List/index.vue'
import { ListAction, ListColumn } from '../../global/components/List/Table.vue'
import { dollarDisplay, prettyDateTime } from '../../global/functions/util'
import { Invoice, InvoicePdf } from '../../global/models'

@Component({
  components: { ListComponent }
})
export default class DisbursementsList extends Vue {
  get filterOptions(): ListFilterOption[] {
    return [
        { text: 'ID', key: 'id', type: 'number' },
        { text: 'Invoice', key: 'invoiceReference', type: 'string' }
    ]
  }

  get availableColumns(): ListColumn<Invoice>[] {
    return [
      { text: 'Issuer', value: 'senderName', type: 'string', fsExclude: true },
      { text: 'Reference', value: 'reference', type: 'string', fsExclude: true },
      { text: 'Total Cost', value: 'totalCost', type: 'number', display: i => this.displayTotalCost(i), fsExclude: true },
      { text: 'Created', value: 'created', type: 'date', display: (date?: string) => prettyDateTime(date) },
      { text: 'Updated', value: 'updated', type: 'date', display: (date?: string) => prettyDateTime(date) }
    ]
  }

  get queryParams() {
    return [['invoiceType[eq]', 'agency-receipt']]
  }

  get defaultColumns() {
    return ['reference', 'totalCost', 'created', 'updated']
  }
  
  get actions(): ListAction<Invoice>[] {
    return [
      { text: 'View', method: (invoice) => this.viewInvoice(invoice) }
    ]
  }

  get list() {
    return this.$refs.list as ListComponent<Invoice>
  }

  displayTotalCost(cost?: string | number | InvoicePdf[]) {
    if (!cost || Array.isArray(cost)) {
      return dollarDisplay(0)
    }
    return dollarDisplay(+cost)
  }

  viewInvoice(invoice: Invoice) {
    this.$router.push({ name: 'receipts-read', params: { id: invoice.id.toString() } })
  }
}
